module.exports = __webpack_public_path__ + "img/32.94af1df4.jpg";